// @generated by protoc-gen-es v1.4.2 with parameter "target=js+dts"
// @generated from file public_api/misc/v1/feature_availability.proto (package public_api.misc.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum public_api.misc.v1.AvailabilityStatus
 */
export const AvailabilityStatus = proto3.makeEnum(
  "public_api.misc.v1.AvailabilityStatus",
  [
    {no: 0, name: "AVAILABILITY_STATUS_UNAVAILABLE", localName: "UNAVAILABLE"},
    {no: 1, name: "AVAILABILITY_STATUS_AVAILABLE", localName: "AVAILABLE"},
  ],
);

/**
 * *
 * Representation of the valid periods by which feature usage can be limited.
 * For example, a feature can be limited to 5 uses within a calendar month (MTD) or 5 uses across
 * the lifetime of the account.
 *
 * @generated from enum public_api.misc.v1.LimitPeriod
 */
export const LimitPeriod = proto3.makeEnum(
  "public_api.misc.v1.LimitPeriod",
  [
    {no: 0, name: "LIMIT_PERIOD_LIFETIME", localName: "LIFETIME"},
    {no: 1, name: "LIMIT_PERIOD_MTD", localName: "MTD"},
    {no: 2, name: "LIMIT_PERIOD_YTD", localName: "YTD"},
  ],
);

/**
 * *
 * Representation of the limit for using a particular feature.
 * For example, a feature can be limited to 5 uses (the count) within a calendar month (the limit period).
 *
 * @generated from message public_api.misc.v1.UsageThreshold
 */
export const UsageThreshold = proto3.makeMessageType(
  "public_api.misc.v1.UsageThreshold",
  () => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "limit_period", kind: "enum", T: proto3.getEnumType(LimitPeriod) },
  ],
);

/**
 * @generated from message public_api.misc.v1.UserFeature
 */
export const UserFeature = proto3.makeMessageType(
  "public_api.misc.v1.UserFeature",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(AvailabilityStatus) },
    { no: 3, name: "threshold", kind: "message", T: UsageThreshold, opt: true },
    { no: 4, name: "usage_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "limit_reached", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message public_api.misc.v1.GetVisibleFeaturesRequest
 */
export const GetVisibleFeaturesRequest = proto3.makeMessageType(
  "public_api.misc.v1.GetVisibleFeaturesRequest",
  [],
);

/**
 * @generated from message public_api.misc.v1.GetVisibleFeaturesResponse
 */
export const GetVisibleFeaturesResponse = proto3.makeMessageType(
  "public_api.misc.v1.GetVisibleFeaturesResponse",
  () => [
    { no: 1, name: "features", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: UserFeature} },
  ],
);

